import { thunk } from 'easy-peasy';

import api from '~/services/api';
import { IThunkGetMedicaidHistory } from '../types';

const onGetMedicaidHistory: IThunkGetMedicaidHistory = thunk(
  async ({ setMedicaidHistory }, requestInfo) => {
    setMedicaidHistory([]);
    const { data } = await api.medicaidPlan.getMedicaidPlanHistory(requestInfo);
    setMedicaidHistory(data);
  },
);

export default onGetMedicaidHistory;
